const { io } = require("socket.io-client")

const socket = io(process.env.VUE_APP_SOCKET, { transports: ["websocket"], secure: true })

export default socket